import { atomFamily, atomWithStorage } from "jotai/utils";
import { AgentMode } from "@/components/ai/prompt-input/agent-mode";

export const agentExecutionInputAtomFamily = atomFamily((environmentId: string) =>
    atomWithStorage<string>(`environment-agent-input-${environmentId}`, ""),
);

export const agentModeAtomFamily = atomFamily((environmentId: string) =>
    atomWithStorage<AgentMode>(`environment-agent-mode-${environmentId}`, AgentMode.Agent),
);
